/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class OrganizationSelectController implements angular.IController{
        public assocaitions: OrganizationalUnitViewModel[];
        public selectedAssociation: OrganizationalUnitViewModel;
        constructor(private $scope: any, private $timeout: ng.ITimeoutService, private organizationService: OrganizationService, private companyService: CompanyService) {
            this.loadOrganizations();
            var vm = this;
            $scope.$on('onCompanySelect', () => {
                vm.loadOrganizations();
            });
        }
        $onInit = () => { };

        private loadOrganizations() {
            var vm = this;
            var companyNumber = this.companyService.getCurrentCompanyNumber();
            if (companyNumber != null && companyNumber != '') {
                vm.organizationService.list().then((data: OrganizationalUnitViewModel[]) => {
                    vm.assocaitions = data;
                    vm.selectedAssociation = null;
                    vm.$scope.vm.selectedItem.next.data = data;
                });
            }
            else {
                vm.assocaitions = [];
                vm.selectedAssociation = null;
                vm.$scope.vm.selectedItem.next.data = [];
            }
        }


        private associationSelected() {
            if (this.selectedAssociation == null) {
                this.$scope.vm.selectedItem.next.data = this.assocaitions;
                return;
            }
            this.$scope.vm.selectedItem.next.data = [ this.selectedAssociation ];
        }
    }

    OrganizationSelectController.$inject = ['$scope', '$timeout', 'OrganizationService', 'CompanyService'];

    angular
        .module('eseebase')
        .controller('OrganizationSelectController', OrganizationSelectController);
}